<template>
<nav class="navbar" :class="{ 'sticky-active': isSticky }">
  <div class="logo">
      <router-link to="/home" @click="closeMenu" class="logo-link">
        <img class="imgBrand" src="@/assets/oztoplogo2.png" alt="My App Logo" />
        <div class="logodesc">
          <span>OZ TOP TEAM</span>
          <!-- <span>LEGAL<sup>™</sup></span> -->
        </div>
      </router-link>
    </div>
    <ul class="nav-links">
      <li><router-link to="/building" @click="closeMenu">Building & Construction</router-link></li>
      <li><router-link to="/finance" @click="closeMenu">Finance</router-link></li>
      <li><router-link to="/legal" @click="closeMenu">Legal</router-link></li>
      <li><router-link to="/education" @click="closeMenu">Education & Training</router-link></li>
      <!-- <li><router-link to="/it">IT</router-link></li>
      <li><router-link to="/travel">Travel</router-link></li>
      <li><router-link to="/migration">Migration</router-link></li> -->
      <li><router-link to="/consulting" @click="closeMenu">Consulting & Marketing</router-link></li>
      <li><router-link to="/advertising" @click="closeMenu">Advertising</router-link></li>
      <li><router-link to="/contact" @click="closeMenu">Contact Us</router-link></li>
    </ul>
    <div class="burger" @click="toggleMenu">
      <span></span>
      <span></span>
      <span></span>
    </div>
  </nav>
</template>

<script>
export default {
  name: "Navbar",
  data() {
    return {
      isSticky: false, // Tracks if navbar is sticky
    };
  },
  mounted() {
    window.addEventListener("scroll", this.checkScroll); // Listen for scroll
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.checkScroll); // Clean up event listener
  },
  methods: {
    toggleMenu() {
      const navLinks = document.querySelector(".nav-links");
      navLinks.classList.toggle("active");
    },
    closeMenu() {
      const navLinks = document.querySelector(".nav-links");
      navLinks.classList.remove("active");
    },
    checkScroll() {
      this.isSticky = window.scrollY > 50; // Add sticky class when scrolled past 50px
    },
  },
};
</script>


<style scoped>
@font-face {
  font-family: "WixMadeforText";
  /* src: url("@/assets/WixMadeforText-Regular.ttf") format("truetype"); */
  src: url("@/assets/manrope_regular.otf") format("opentype");
  font-weight: normal;
  font-style: normal;
}
.logo-link {
  display: flex;
  align-items: center;
  text-decoration: none;
}
/* Default styling for the navbar */
.navbar {
  display: flex;
  align-items: center;
  background-color: #404356;
  padding: 10px 20px;
  position:sticky;
  top: 0;
  place-content: space-between;
  border-radius: 15px;
    margin: 3px;
    z-index: 9999; 
}
.logo{
  display:inherit;
}
.logodesc{
    color: #eae9d5;
    display: inline-grid;
    font-family: 'WixMadeforText';
    font-weight: bold;
    align-content: center;
    /* background-color: #404356; */
}
.imgBrand {
  width: 20%;
}

.logo a {
  color: white;
  font-size: 15px;
  text-decoration: none;
  font-weight: bold;
}

.nav-links {
  list-style: none;
  display: flex;
  gap: 15px; /* Adds space between links */
  opacity: 0; /* Start hidden */
  transform: translateY(-10px); /* Slight upward offset for animation */
  transition: opacity 0.3s ease, transform 0.3s ease; /* Smooth fade and slide */
  
}

.nav-links li {
  background-color: rgba(64, 67, 86, 1);
    -webkit-backdrop-filter: none;
    backdrop-filter: none;
    border-radius: 59px;
    margin: 0.3%;
    flex: 1;
    text-align: -webkit-center;
    padding: 0.45%;
    border-color: #404356;
    border-style: solid;
    border-width: 1px;
}

.nav-links a {
  color: #eae9d5;
  text-decoration: none;
  font-size: 20px;
  font-family: "WixMadeforText", sans-serif; /* Apply the custom font */
  transition: color 0.3s;
}

.nav-links a:hover {
  color: #00bcd4; /* Highlight color on hover */
}

.burger {
  display: none;
  flex-direction: column;
  cursor: pointer;
  margin-right: 13%;
}

.burger span {
  background-color: white;
  height: 3px;
  width: 25px;
  margin: 5px 0;
}
.sticky-active {
  background-color: rgba(64, 67, 86, 0.5) !important; /* Semi-transparent */
  backdrop-filter: blur(10px) !important;  
  transition: background-color 0.3s ease, backdrop-filter 0.3s ease;
  position: sticky !important; /* Force sticky position when active */
  top: 1.5%;
  z-index:1000;
}



/* Mobile Styles */
@media screen and (max-width: 768px) {
  .nav-links {
    position: absolute;
        left: 2%;
        top: 104%;
        padding: 5%;
        /* height: 66%; */
        right: 0%;
        background-color: #404356;
        width: 87%;
        /* height: 100vh; */
        flex-direction: column;
        
        /* align-items: center; */
        /* justify-content: center; */
        pointer-events: none;
        align-items: anchor-center;
  }
.nav-links li{
  border-radius: 59px;
    text-align: center;
    /* justify-self: center; */
    margin: 1.3%;
    padding: 2.45%;
    border-color: darkgrey;
    border-style: solid;
    border-width: 1px;
    width: 85%;
    background-color: #404356;
}
  .nav-links.active {
    opacity: 1; /* Fade in */
    transform: translateY(0); /* Reset transform */
    pointer-events: auto; /* Enable clicks when visible */ 
    border-radius: 17px;
    background-color: rgba(64, 67, 86, 0.5); /* Lighter transparency */
backdrop-filter: blur(10px); /* Adds a blur effect */

  }

  .burger {
    display: flex;
  }
}

/* Desktop Styles */
@media screen and (min-width: 769px) {
  .nav-links {
    display: contents;
    position: static;
    height: auto;
    background: none;
    flex-direction: row;
    opacity: 1; /* Always visible on desktop */
    transform: none; /* No animation on desktop */
    justify-content: center;
  }
  .nav-links a {
    font-size: 13px;
  }
  .imgBrand {
    width: 47px;
  }
  .burger {
    display: none;
  }
}
</style>
